import type { CartItem } from '@features/cart/types';

export const COMMERCE_CART_SCHEMA_VERSION = 2;
export const ANONYMOUS_CART_OWNER = 'anonymous';

export type CartOwnerId = string | null | undefined;

export interface StoredCommerceCart {
  version: typeof COMMERCE_CART_SCHEMA_VERSION;
  owner: string;
  updatedAt: string;
  items: CartItem[];
}

export interface CartMutationMeta {
  source: 'local' | 'storage' | 'broadcast' | 'migration';
  owner: string;
}
